































import { Component, Vue, Prop } from 'vue-property-decorator'
import { assignRole, roleDetail } from '@/api/manage/roleManage'
import { TreeObj, RoleSettingData } from '@/types/manage/roleManage'
import moduleHeader from '@/components/moduleHeader/index.vue'
import { Tree } from 'element-ui'
import { cloneDeep } from 'lodash'

@Component({
  name: 'template',
  components: {
    moduleHeader
  }
})
export default class extends Vue {
  @Prop({ required: true }) private dataObj!: any
  cloneData = []
  selectKeys: string[] = []
  activeName = '1'
  expandKeys: string[] = []
  checkKeys: string[] = []
  roleId =''
  allowIds = ['1801', '1802', '1803', '1804', '1805', '1806','1807', '1808', '1903', '1906', '1907','1908']
  childrenIds = ['18', '19']
  roleSettingData: RoleSettingData = {
    roleResourceInfoList: [],
    roleResources: []
  }

  defaultProps = {
    children: 'subResources',
    label: 'name',
    isLeaf: 'leaf'
  }

  created () {
    this.roleId = (this.$route.query.roleId as string)
    this.onRoleDetail()
  }

  async confirm () {
    this.selectKeys = (this.$refs.roleTree as Tree).getCheckedKeys()
    const temp = this.endFilter()
    // const temp = this.selectKeys.map((item) => {
    //   return { resourceId: item }
    // })
    if (temp.length === 0) {
      this.$message.error('请至少选择一项权限')
      return
    }
    this.roleSettingData.roleResources = temp
    const res = await assignRole(this.dataObj.assignUrl, this.roleSettingData)
    if (res.statusCode === 0 && res.data) {
      this.$message.success(res.data)
      this.$router.back()
      // this.onRoleDetail()
    }
  }

  // @ts-ignore
  renderContent (h, { node }) {
    return (
      <span class="custom-tree-node">
        <span>{node.label}</span>
      </span>)
  }

  filterKeys (data: TreeObj[]) {
    const extendArr: string[] = []
    const checkedArr: string[] = []
    const filterData = (data: any) => {
      data.forEach((item: TreeObj) => {
        if (item.assigned === 1 && item.resourceId.length >= 2 && !this.childrenIds.includes(item.resourceId)) {
          checkedArr.push(item.resourceId)
        }
        if (item.resourceId.length <= 2) {
          extendArr.push(item.resourceId)
        }
        if (item.subResources.length > 0) {
          filterData(item.subResources)
        }
      })
    }
    filterData(data)
    // console.log('filterKeys data', data)
    // console.log('extendArr', extendArr)
    console.log('checkedArr', checkedArr)
    this.checkKeys = checkedArr
    this.expandKeys = extendArr
  }

  handleClick (tab: string, event: Event) {
    console.log(tab, event)
  }

  beganFilter (data: any) {
    // console.log('data11', data)
    const filterData = (data: any) => {
      return data.filter((item: any) => {
        if (item.resourceId.length < 4 || this.allowIds.includes(item.resourceId)) {
          return true
        }
      }).map((item: any) => {
        // console.log('item', item)
        item = Object.assign({}, item)
        if (item.subResources) {
          item.subResources = filterData(item.subResources)
        }
        return item
      })
    }
    const flagData = filterData(data)
    console.log('flagData', flagData)
    return flagData
  }

  endFilter () {
    const temp: any = []
    const onEndFilter = (data: any) => {
      data.forEach((item: any) => {
        if (this.selectKeys.includes(item.resourceId)) {
          temp.push({ resourceId: item.resourceId })
          if (item.parentId && !this.selectKeys.includes(item.parentId)) {
            temp.push({ resourceId: item.parentId })
          }
        }
        if (item.parentId && this.selectKeys.includes(item.parentId)) {
          temp.push({ resourceId: item.resourceId })
        }
        if (item.subResources.length > 0) {
          onEndFilter(item.subResources)
        }
      })
    }
    onEndFilter(this.cloneData)
    console.log('endFilter temp', temp)
    return temp
  }

  async onRoleDetail () {
    const res = await roleDetail(this.dataObj.detailUrl, {
      roleId: this.roleId
    })
    if (res.statusCode === 0 && res.data) {
      const { roleResourceInfoList } = res.data
      this.cloneData = cloneDeep(roleResourceInfoList)
      this.roleSettingData = res.data
      const treeData = this.beganFilter(roleResourceInfoList)
      console.log('treeData', treeData)
      this.filterKeys(treeData)
      this.roleSettingData.roleResourceInfoList = treeData
    }

    // console.log('res22', res)
  }

  setDeepData (data: TreeObj) {
    const bool = data.assigned === 1 ? 0 : 1
    function changeValue (data: any) {
      data.assigned = bool
      if (data.subResources.length > 0) {
        data.subResources.forEach((item: TreeObj) => {
          changeValue(item)
        })
      }
    }
    changeValue(data)
  }

  check (data: TreeObj) {
    this.setDeepData(data)
  }

  cancel () {
    this.$router.back()
  }

  mounted () {
    // this.$nextTick(() => {
    //   setInterval(() => {
    //     const childrenNode:HTMLCollectionOf<Element> = document.getElementsByClassName('is-leaf')
    //     Array.prototype.forEach.call(childrenNode, (ele: Element) => {
    //     // @ts-ignore
    //       ele.parentNode.parentNode.style.display = 'inline-block'
    //       // ele.parentNode.parentNode.style.visibility = 'hidden'
    //     })
    //     console.log('childrenNode', childrenNode.length)
    //   }, 20)
    // })

    // if(childrenNode)
  }
}
